import { Antwoord, ValidatieParameter } from '@models/claims';
import { ValidatieregelHelper } from '@services/public_api';

export class AntwoordHelper {
  static antwoordTonenBijLineOfBusiness(antwoord: Antwoord, lob: string): boolean {
    if (!lob) {
      return true;
    }

    const productValidator: ValidatieParameter = ValidatieregelHelper.get(antwoord.validatieParameters, 'PRODUCT');

    // geen validatie op product
    if (productValidator == null || !productValidator.validatie_parameters || productValidator.validatie_parameters === null) {
      return true;
    }

    const productItems = productValidator.validatie_parameters.toUpperCase().split(';');

    return (productItems?.indexOf(lob.toUpperCase()) > -1);
  }
}
